import {makeCallTest} from 'backend/utilities';
import {getBase64} from 'public/utilities.js'

$w.onReady(function () {
	$w("#singlePostController2").onWixFormSubmitted((event) => {
		console.log('Chrome console: site loaded');
		let email = event.fields[0].fieldValue;
		let name = email.split('@')[0];
		let surname = email.split('@')[0];
		let phone = null;

		const base64Promise = getBase64(surname, name, email);
		base64Promise.then((base64) => {
			makeCallTest(base64, name, surname, email, phone);
		})
	})
});